new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
      
    },
})

$(document).ready(function () {

    if (window.matchMedia("(max-width: 991px)").matches) {
        const allFooterTitles = document.querySelectorAll('.footer-section');
        if (allFooterTitles.length > 0) {
          allFooterTitles.forEach(filter => {
              const title = filter.querySelector('.footer-title');
              const submenu = filter.querySelector('.footer-section--content');
    
              if (title && submenu) {
                // pega altura real do conteúdo
                const height = submenu.scrollHeight;
                submenu.style.height = `${height}px`;
                title.addEventListener('click', () => {
                  title.classList.toggle('active');
                  submenu.classList.toggle('active');
                });
                title.classList.add('active');
                submenu.classList.add('active');
              }
          });
        }
    }

});